import React, { createContext, useEffect, useState, useCallback, useContext } from "react";
import axiosInstance from "./axiosConfig";
import { AuthContext } from "./AuthContext";

export const PollingContext = createContext();

export const PollingProvider = ({ children }) => {
  const [activityDetected, setActivityDetected] = useState(false);
  const { logout } = useContext(AuthContext);

  const updateResources = useCallback(async () => {
    try {
      await axiosInstance.post("/api/departments/update-resources");
      console.log("Resources updated successfully!");
    } catch (error) {
      console.error("Error updating resources globally:", error);
    }
  }, []);

  const updateSessionCheck = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const EmployeeID = user?.EmployeeID;
      const deviceToken = localStorage.getItem("deviceToken");

      if (!deviceToken) return;

      /*const res = await axiosInstance.post(
        "/api/session-check",
        {
          deviceToken: deviceToken,
          EmployeeID: EmployeeID
        },
        {
          withCredentials: true
        }
      );*/

      // if (res.data.logout === true) {

      //   alert("Your session has been terminated by Admin.");

      //   await logout();  

      //   localStorage.removeItem('user');
      //   localStorage.removeItem('loginTime');
      //   localStorage.removeItem('sessionExpiration');
      //   localStorage.removeItem('userData');

      //   // window.location.href = "/";

      // }

    } catch (error) {
      console.error("Session check error:", error);
    }
  }, []);

  const pollUserActivity = useCallback(() => {
    const intervalId = setInterval(async () => {
      try {
        const response = await axiosInstance.get("/api/user-activity/recent");
        const isActivityDetected = response.data.activityDetected;

        if (isActivityDetected && !activityDetected) {
          console.log("Activity detected globally!");
          setActivityDetected(true);
          updateResources(); // Trigger updateResources globally
        } else if (!isActivityDetected && activityDetected) {
          setActivityDetected(false);
        }
      } catch (error) {
        console.error("Error polling for user activity:", error);
      }
    }, 5000); // Poll every 500 milliseconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [activityDetected, updateResources]);

  useEffect(() => {
    const stopPolling = pollUserActivity();
    return stopPolling; // Cleanup polling on provider unmount
  }, [pollUserActivity]);

  useEffect(() => {

    const interval = setInterval(() => {
      updateSessionCheck();
    }, 5000); // 5000 ms = 5 seconds

    return () => clearInterval(interval);

  }, [updateSessionCheck]);

  return (
    <PollingContext.Provider value={{ activityDetected }}>
      {children}
    </PollingContext.Provider>
  );
};
